import { useStepperContext } from '@folio/components/layout';
import { cn } from '@folio/lib';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../ui';

export const StepperFooter = ({
  className,
  onNext,
  loading,
  nextButtonEnabled = true,
  showNextButton = true,
  showPreviousButton = true,
  nextButtonText,
  previousButtonText,
  secondaryAction,
}: {
  className?: string;
  onNext?: () => void;
  loading?: boolean;
  nextButtonEnabled?: boolean;
  showNextButton?: boolean;
  showPreviousButton?: boolean;
  nextButtonText?: string;
  previousButtonText?: string;
  /** Rendered immediately left of the next button, sharing its side of the footer. */
  secondaryAction?: ReactNode;
}) => {
  const { previous, next, isFirstStep, isSingleStep, afterEndPath } = useStepperContext();
  const { t } = useTranslation();

  if (isSingleStep && !afterEndPath) {
    return null;
  }

  return (
    <div className={cn('flex justify-between flex-row-reverse', className)}>
      <div className="flex flex-row-reverse items-center gap-3">
        {showNextButton ? (
          <Button
            className="flex items-center gap-2"
            onClick={onNext ?? (() => next())}
            disabled={loading || !nextButtonEnabled}
            loading={loading}
          >
            <div>{nextButtonText ?? t('stepper.next')}</div>
          </Button>
        ) : (
          <div />
        )}
        {secondaryAction}
      </div>
      {showPreviousButton && (
        <Button type="button" variant="outline" onClick={() => previous()} disabled={isFirstStep}>
          {previousButtonText ?? t('stepper.previous')}
        </Button>
      )}
    </div>
  );
};
